import type { EntityStatus } from '@core';
import type { SpaceType } from '@locations/models';
import type { IncidentSeverity } from '@models';

export interface Coordinates {
  height: number;
  left: number;
  top: number;
  width: number;
}

export interface SpaceplanViewport {
  height: number;
  left: number;
  top: number;
  width: number;
}

export enum SpaceplanTabType {
  AUDIO = 'audio',
  CONTROL = 'control',
  NETWORK = 'network',
  VIDEO = 'video',
  FLOORPLAN = 'floorplan',
}

export interface AttachmentPosition {
  coordinates: Coordinates & Partial<Record<SpaceplanTabType, Coordinates>>;
}

export interface AttachmentItemModel {
  deviceId?: string;
  deviceName?: string;
  friendlyName: string;
  id: string;
  incidentCountBySeverity: Record<IncidentSeverity, number>;
  severity?: IncidentSeverity;
  status: EntityStatus;
  type?: SpaceType;
  unstructuredDataReference: string;
}

export interface SpaceplanModel {
  attachments: AttachmentItemModel[];
  documentReference: string;
  id: string;
  parentSpaceId: string | null;
}

export interface ImageDocument {
  contentType: string;
  fileName: string;
  fileSizeInBytes: number;
  tab: SpaceplanTabType | null;
  uploadedOn: string;
}

export const isSpaceplanTabType = (documentTab: string): documentTab is SpaceplanTabType =>
  Object.values(SpaceplanTabType).includes(documentTab as SpaceplanTabType);
